<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div class="card">
	<div class="card-header bg-theme">
		Question Translation
	</div>
	<div class="card-body">
		<div class="row mb-2">
			<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
				<ng-select id="category" [items]="allCategories" bindLabel="name" bindValue="id" [clearable]="false"
					placeholder="Category" [(ngModel)]="filter.category" (change)="refreshTable()" appearance="outline">
				</ng-select>
			</div>
		</div>
		<div class="row mb-2">
			<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
				<div class="table-responsive">
					<table datatable [dtOptions]="dtOptions" class="table table-striped table-bordered table-hover"
						*ngIf="filter.category">
						<tbody *ngIf="dataList?.length != 0">
							<tr *ngFor="let v of dataList;let i = index;">
								<td style="width: 10%;">
									<strong style="font-size: x-large;">
										Q. {{ i+1+start }}
									</strong>
								</td>
								<td style="width: 90%;">
									<div class="row">
										<div class="col-md-12">
											<label class="control-label">Question</label>
											<input type="text" id="question_{{i}}" name="question_{{i}}"
												[(ngModel)]="v.question_name" class="form-control"
												value="{{ v.question_name }}" />
										</div>
									</div>
									<div class="row">
										<div class="col-md-12">
											<label class="control-label">Translation</label>
											<input type="text" id="translation_{{i}}" name="translation_{{i}}"
												[(ngModel)]="v.translation" class="form-control"
												value="{{ v.translation }}" />
										</div>
									</div>
								</td>
							</tr>
						</tbody>
						<tbody *ngIf="dataList?.length == 0">
							<tr>
								<td colspan="2" class="text-center">No data found!</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div class="row mb-2">
			<div class="col-md-12">
				<button *ngIf="dataList?.length != 0" type="button" class="btn btn-sm btn-outline-primary"
					(click)="save_translation()">
					<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
					<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
					Save
				</button>
			</div>
		</div>
	</div>
</div>